import React, { use, useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { Bar } from "react-chartjs-2";
import allTeams from '../../data/teams';
import { Chart as ChartJS } from "chart.js/auto"; // Tout est déjà enregistré
import { TeamContext } from '../context/TeamContext';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';
import { visuallyHidden } from '@mui/utils';
import { Height } from "@mui/icons-material";
import renderTeamsStanding from "./teamsStanding";

interface Team {
    conferenceAbbrev: string;
    conferenceHomeSequence: number;
    conferenceL10Sequence: number;
    conferenceName: string;
    conferenceRoadSequence: number;
    conferenceSequence: number;
    date: string;
    divisionAbbrev: string;
    divisionHomeSequence: number;
    divisionL10Sequence: number;
    divisionName: string;
    divisionRoadSequence: number;
    divisionSequence: number;
    gameTypeId: number;
    gamesPlayed: number;
    goalAgainst: number;
    goalDifferential: number;
    goalDifferentialPctg: number;
    goalFor: number;
    goalsForPctg: number;
    homeGamesPlayed: number;
    homeGoalDifferential: number;
    homeGoalsAgainst: number;
    homeGoalsFor: number;
    homeLosses: number;
    homeOtLosses: number;
    homePoints: number;
    homeRegulationPlusOtWins: number;
    homeRegulationWins: number;
    homeTies: number;
    homeWins: number;
    l10GamesPlayed: number;
    l10GoalDifferential: number;
    l10GoalsAgainst: number;
    l10GoalsFor: number;
    l10Losses: number;
    l10OtLosses: number;
    l10Points: number;
    l10RegulationPlusOtWins: number;
    l10RegulationWins: number;
    l10Ties: number;
    l10Wins: number;
    leagueHomeSequence: number;
    leagueL10Sequence: number;
    leagueRoadSequence: number;
    leagueSequence: number;
    losses: number;
    otLosses: number;
    placeName: { default: string };
    pointPctg: number;
    points: number;
    regulationPlusOtWinPctg: number;
    regulationPlusOtWins: number;
    regulationWinPctg: number;
    regulationWins: number;
    roadGamesPlayed: number;
    roadGoalDifferential: number;
    roadGoalsAgainst: number;
    roadGoalsFor: number;
    roadLosses: number;
    roadOtLosses: number;
    roadPoints: number;
    roadRegulationPlusOtWins: number;
    roadRegulationWins: number;
    roadTies: number;
    roadWins: number;
    seasonId: number;
    shootoutLosses: number;
    shootoutWins: number;
    streakCode: string;
    streakCount: number;
    teamAbbrev: { default: string };
    teamCommonName: { default: string };
    teamLogo: string;
    teamName: { default: string; fr?: string };
    ties: number;
    waiversSequence: number;
    wildcardSequence: number;
    winPctg: number;
    wins: number;
  }
  
  function createData(team: Team): Team {
    return { ...team };
  }

interface DivisionProps {
    teamsStanding: any; // Replace 'any' with the appropriate type if known
}

const Division: React.FC<DivisionProps> = ({ teamsStanding }) => {    
    const [teams, setTeams] = useState(teamsStanding || []);
    const {setTeamSelected} = useContext(TeamContext);

    return (
    <div>
        <div className="title">Atlantic Division</div>
        {renderTeamsStanding('division', 'Atlantic', teams)}
        <div className="title">Metropolitan Division</div>
        {renderTeamsStanding('division', 'Metropolitan', teams)}
        <div className="title">Central Division</div>
        {renderTeamsStanding('division', 'Central', teams)}
        <div className="title">Pacific Division</div>
        {renderTeamsStanding('division', 'Pacific', teams)}
    </div>);
};

export default Division;
;